module.exports = {
    logout: "Odhlásiť sa",
    logout_mini: "O"
  }